import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ApiError } from '@/lib/api'

type LoadErrorProps = { error: unknown; className?: string; children?: ReactNode }

/** Torneo o partita che non si caricano: 404 → "non trovato" (link vecchio, torneo eliminato), altrimenti
 * errore generico (rete). */
export function LoadError({ error, className, children }: LoadErrorProps) {
  const { t } = useTranslation()
  const isNotFound = error instanceof ApiError && error.status === 404
  return (
    <div role="alert" className={className}>
      <p className="font-body text-lg">{t(isNotFound ? 'stoccoPong.error.notFound' : 'stoccoPong.error.load')}</p>
      {children}
    </div>
  )
}
